import { useTranslation } from "react-i18next"
import Select from "../Select/Select"
import { useState, useEffect } from "react"

function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const [value, setValue] = useState(i18n.language.split("-")[0].toLowerCase())

  useEffect(() => {
    setValue(i18n.language.split("-")[0].toLowerCase())
  }, [i18n.language])

  const languages = {
    fr: "FR",
    en: "EN"
  }

  async function changeLanguage(langKey) {
    if (langKey && langKey !== i18n.language.split("-")[0].toLowerCase()) {
      try {
        await i18n.changeLanguage(langKey.toLowerCase())
        setValue(langKey.toLowerCase())
      } catch (err) {
        console.error("Erreur changement langue :", err)
      }
    }
  }

  return (
    <Select
      value={value}
      options={languages}
      onChange={changeLanguage}
      style={{ maxWidth: "94px" }}
    />
  )
}

export default LanguageSwitcher